import { render, staticRenderFns } from "./FreeBetsSelector.vue?vue&type=template&id=c6333202&scoped=true"
import script from "./FreeBetsSelector.vue?vue&type=script&lang=js"
export * from "./FreeBetsSelector.vue?vue&type=script&lang=js"
import style0 from "./FreeBetsSelector.vue?vue&type=style&index=0&id=c6333202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6333202",
  null
  
)

export default component.exports